import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiClient } from "../../utils/apiClient";
import { RequestType } from "@secure-caseworker/shared";
import { EmailVerification } from "./EmailVerification";

type VerificationStatus = "loading" | "success" | "error";

export const RecipientEmailVerification: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<VerificationStatus>("loading");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setError("Verification token is missing");
      return;
    }

    const verifyEmail = async () => {
      try {
        const data = await apiClient.verifyParticipantEmail(token);

        if (!data.success) {
          setStatus("error");
          setError(data.error || "Failed to verify email. Please try again.");
          return;
        }

        setStatus("success");

        // Redirect to sign page with participant token and verification token
        if (data.participantToken) {
          const resolvedTemplate: any =
            await apiClient.resolveParticipantTemplateToken(
              data.participantToken,
            );

          setTimeout(() => {
            if (resolvedTemplate.requestType === RequestType.FORM) {
              navigate(
                `/request/form/${data.participantToken}?verificationToken=${token}`,
              );
            }

            if (resolvedTemplate.requestType === RequestType.SIGNATURE) {
              navigate(
                `/request/sign/${data.participantToken}?verificationToken=${token}`,
              );
            }
            // no op
            setError("Something went wrong. Contact support.");
          }, 1500);
        }
      } catch (err) {
        setStatus("error");
        setError("Network error. Please check your connection and try again.");
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <EmailVerification
      status={status}
      loadingMessage="Verifying your email..."
      successMessage="Your email has been successfully verified. Redirecting you..."
      errorMessage={error}
      onErrorAction={() => navigate("/request/expired")}
      errorActionLabel="Request New Link"
    />
  );
};
